import script from "./VisibleSelectorWidget.vue?vue&type=script&lang=js"
export * from "./VisibleSelectorWidget.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__